import { CURRICULUM_KEYS } from '@mathflat/domain/@entities/Curriculum/constant'
import { tJosa } from '@mathflat/shared/i18n/tJosa'
import { rangeRight } from 'lodash-es'
import type { Sorts } from 'src/dto/common/ReqParams'

import type { PoliceMilitaryPracticeTestFilterParamT } from '@/page/Lesson-prepare/LessonMaterial/lessonMaterial'
// TODO: 전체적으로 이름 변경 필요
export const ARITHMETIC_TAGS = {
  ELEMENTARY: {
    [CURRICULUM_KEYS.CURRICULUM_KEY_초등학교_1학년_1학기]: {
      '대단원 전체': '11101,11102,11103,11104',
      '9까지의 수': '11101',
      '가르기와 모으기': '11102',
      '덧셈과 뺄셈': '11103',
      '50까지의 수': '11104',
    },
    [CURRICULUM_KEYS.CURRICULUM_KEY_초등학교_1학년_1학기_22개정]: {
      '대단원 전체': '111001,111002,111003,111004',
      '9까지의 수': '111001',
      '가르기와 모으기': '111002',
      '덧셈과 뺄셈': '111003',
      '50까지의 수': '111004',
    },
    [CURRICULUM_KEYS.CURRICULUM_KEY_초등학교_1학년_2학기]: {
      '대단원 전체': '11201,11202,11203,11204,11205,11206',
      '100까지의 수': '11201',
      '받아올림이 없는 100까지 수의 덧셈': '11202',
      '받아내림이 없는 100까지 수의 뺄셈': '11203',
      '받아올림이 없는 세 한 자리 수의 덧셈과 뺄셈': '11204',
      '받아올림/내림이 없는 두 자리 수의 혼합계산': '11205',
      '받아올림/내림이 있는 수의 덧셈과 뺄셈': '11206',
    },
    [CURRICULUM_KEYS.CURRICULUM_KEY_초등학교_1학년_2학기_22개정]: {
      '대단원 전체': '112001,112002,112003,112004,112005,112006',
      '100까지의 수': '112001',
      '받아올림이 없는 100까지 수의 덧셈': '112002',
      '받아내림이 없는 100까지 수의 뺄셈': '112003',
      '받아올림이 없는 세 한 자리 수의 덧셈과 뺄셈': '112004',
      '받아올림/내림이 없는 두 자리 수의 혼합계산': '112005',
      '받아올림/내림이 있는 수의 덧셈과 뺄셈': '112006',
    },
    [CURRICULUM_KEYS.CURRICULUM_KEY_초등학교_2학년_1학기]: {
      '대단원 전체': '12101,12102,12103,12104,12105,12106',
      '세 자리 수': '12101',
      '두 자리 수의 덧셈': '12102',
      '두 자리 수의 뺄셈': '12103',
      '덧셈과 뺄셈의 관계': '12104',
      '세 수의 덧셈과 뺄셈': '12105',
      곱셈식: '12106',
    },
    [CURRICULUM_KEYS.CURRICULUM_KEY_초등학교_2학년_1학기_22개정]: {
      '대단원 전체': '121001,121002,121003,121004,121005,121006',
      '세 자리 수': '121001',
      '두 자리 수의 덧셈': '121002',
      '두 자리 수의 뺄셈': '121003',
      '덧셈과 뺄셈의 관계': '121004',
      '세 수의 덧셈과 뺄셈': '121005',
      곱셈식: '121006',
    },
    [CURRICULUM_KEYS.CURRICULUM_KEY_초등학교_2학년_2학기]: {
      '대단원 전체': '12201,12202,12203,12204',
      '네 자리 수': '12201',
      곱셈구구: '12202',
      길이: '12203',
      시간: '12204',
    },
    [CURRICULUM_KEYS.CURRICULUM_KEY_초등학교_2학년_2학기_22개정]: {
      '대단원 전체': '122001,122002,122003,122004',
      '네 자리 수': '122001',
      곱셈구구: '122002',
      길이: '122003',
      시간: '122004',
    },
  },
} as const

export const PROBLEM_SORTING = [
  '사용자 정렬',
  '유형 오름차순',
  '난이도 오름차순',
  '객관식 상단 배치',
  '랜덤 정렬',
] as const

export const PROBLEM_SORT_FILTER: readonly {
  label: string
  value: common.MakeWorksheetProblemSortType
}[] = [
  { label: '유형 오름차순', value: 'CONCEPT' },
  { label: '난이도 오름차순', value: 'LEVEL' },
  { label: '객관식 상단배치', value: 'SINGLE_CHOICE' },
  { label: '무작위', value: 'RANDOM' },
  { label: '문제 순 정렬', value: 'PROBLEM' },
  { label: '사용자 정렬', value: 'USER' },
] as const

export const CONCEPT_SORT_FILTER = [
  { label: '연관된 문제 앞', value: 'RELATION' },
  { label: '학습지 맨 앞', value: 'FRONT' },
  { label: '사용자 정렬', value: 'USER' },
] as const

export const PROBLEM_IMAGE_FILTER = [
  { label: '문제만 보기', value: 'ONLY_PROBLEM' },
  { label: '문제 + 정답', value: 'PROBLEM&COMMENTARY' },
  { label: '문제 + 해설 + 정답', value: 'ALL' },
] as const

const makeYearDropdownList = ({ startYear, endYear }: { startYear: number; endYear?: number }) => {
  const _endYear = endYear ? endYear + 1 : new Date().getFullYear() + 1
  return [
    { value: null, label: '연도 전체' } as const,
    ...rangeRight(startYear, _endYear).map((year) => ({
      value: year,
      label: `${year}년`,
    })),
  ]
}

/** 수능/모의고사 필터 연도 */
export const YEAR_LABEL_EXPANDED = makeYearDropdownList({
  startYear: 2004,
  endYear: 2026,
})
/** 수능특강/수능완성 필터 연도 */
export const SAT_WORKSHEET_YEAR_LABEL = makeYearDropdownList({
  startYear: 2022,
  endYear: 2026,
})
/** 경찰대 사관학교 필터 */
export const POLICE_MILITARY_TEST_YEAR_LABEL = makeYearDropdownList({
  startYear: 2021,
  endYear: 2025,
})
export const POLICE_MILITARY_TEST_TYPE_LABEL: {
  value: PoliceMilitaryPracticeTestFilterParamT['universityTypes']
  label: string
}[] = [
  { value: null, label: '구분 전체' },
  { value: 'POLICE_UNIVERSITY', label: '경찰대' },
  { value: 'MILITARY_ACADEMY', label: '사관학교' },
] as const

export const MONTH_LABEL = [
  { value: 3, label: '3월' },
  { value: 4, label: '4월' },
  { value: 5, label: '5월' },
  { value: 6, label: '6월' },
  { value: 7, label: '7월' },
  { value: 9, label: '9월' },
  { value: 10, label: '10월' },
  { value: 11, label: '11월' },
] as const

export type MonthLabelExpandedValue = (typeof MONTH_LABEL)[number]['value'] | null

export const getMonthLabelExpanded = () => [
  { value: null, label: `${tJosa('출제')} 월 전체` },
  ...MONTH_LABEL,
]

export const WORKSHEET_TYPE = {
  CONCEPT: '단원유형별',
  PUBLIC_WORKBOOK: '시중교재',
  PRACTICE_TEST: '수능모의고사',
  SCHOOL_TEST: '학교별 기출',
  MERGED_WORKSHEET: '병합 학습지',
} as const

export const STUDENT_WORKBOOK_BY_ROUND_SORTING: Sorts = [
  ['progressMaxUpdatetime', 'DESC'],
  ['studentName', 'ASC'],
]
